import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import Popup from '../Popup';

import style from './Layout.scss';

class Layout extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <div className={style.root}>
        {this.props.children}
        <Popup />
      </div>
    );
  }
}

export default withStyles(style)(Layout);
